import * as angular from "angular";
import entityBusiness from "./entity-business/entity-business.js";
import entityBusinessModal from "./entity-business/entity-business-modal/entity-business-modal.js";
import entityBusinessProfile from "./entity-business/entity-business-profile/entity-business-profile.js";
import entityBusinessCharges from "./entity-business/entity-business-charges/entity-business-charges.js";
import entityBusinessChargeModal from "./entity-business/entity-business-charges/entity-business-charge-modal/entity-business-charge-modal.js";
import entityBusinessProducts from "./entity-business/entity-business-products/entity-business-products.js";
import entityBusinessProductModal from "./entity-business/entity-business-products/entity-business-product-modal/entity-business-product-modal.js";
import entityClassifications from "./entity-classifications/entity-classifications.js";
import entityContact from "./entity-contact/entity-contact";
import entityContactModal from "./entity-contact/entity-contact-modal/entity-contact-modal";
import entityContacts from "./entity-contacts/entity-contacts.js";
import entityCustomer from "./entity-customer/entity-customer.js";
import entityCustomerTransactions from "./entity-customer/entity-customer-transactions/entity-customer-transactions.js";
import entityEffectiveRanges from "./entity-effective-ranges/entity-effective-ranges.js";
import editEffectiveRangeModal from "./entity-effective-ranges/edit-effective-range/edit-effective-range";
import entityForm from "./entity-form/entity-form.js";
import entityIdentifiers from "./entity-identifiers/entity-identifiers.js";
import entityInventory, { inventoryOperationsModal } from "./entity-inventory/entity-inventory.js";
import entityReporting from "./entity-reporting/entity-reporting.js";
import editNextNumber from "./entity-reporting/edit-report-number/edit-report-number";
import entityTokens from "./entity-tokens/entity-tokens.js";
import entityUsers from "./entity-users/entity-users.js";

export default angular
	.module("vesl.components.entity-modal.tabs.components", [
		entityBusiness,
		entityBusinessModal,
		entityBusinessProfile,
		entityBusinessCharges,
		entityBusinessChargeModal,
		entityBusinessProducts,
		entityBusinessProductModal,
		entityClassifications,
		entityContact,
		entityContactModal,
		entityContacts,
		entityCustomer,
		entityCustomerTransactions,
		entityEffectiveRanges,
		editEffectiveRangeModal,
		entityForm,
		entityIdentifiers,
		entityInventory,
		inventoryOperationsModal,
		entityReporting,
		editNextNumber,
		entityTokens,
		entityUsers
	])
	.name;
